<div class="page" id="homepage" #homepage>
  <div class="visually_hidden" id="page_title" role="title" tabindex="-1"></div>
  <common-header-control
    [inputId]="'contactUsHeader'"
    [inputLoggedIn]="true"
    [inputLinksData]="isCahoot ? this.navigationCahootLinks : this.navigationLinks"
    [inputImagesPath]="isCahoot ? 'assets/cahoot/' : 'assets/img/'"
    [inputLogoNames]="isCahoot ? this.cahootLogos : this.logos"
    [inputMobileLogoNames]="isCahoot ? this.cahootLogos : this.mobileLogos"
    [inputDesktopClasses]="this.loadCss"
    [inputMobileClasses]="'mobile-brand-logo'"
    (messageEvent)="onClickHeaderTextLinks($event)"
  >
  </common-header-control>
  
  <main>
    <div id="content" class="container">
      <olb-app-contact-us [userAuthenticated]="userAuthenticated" [dataLoaded]="dataLoaded"></olb-app-contact-us>
    </div>
  </main>
  <footer>
    <olb-app-footer></olb-app-footer>
  </footer>
  <common-session-timeout
    [timeoutLength]="270"
    [popupLength]="30"
    [host]="host"
    [isCahoot]="isCahoot"
  ></common-session-timeout>
</div>
